module.exports = __webpack_public_path__ + "90.png";